import axios from 'axios'

const URL = process.env.REACT_APP_BACKEND_API

const api = axios.create({
  baseURL: URL,
  auth: {
    username: 'admin',
    password: 'admin',
  },
})

export default api
